module.exports = "//cdn.mxpnl.com/static/asset-cache/58f8a3139a8c0a0bf3fda3fcb71acbda/iron/common/assets/images/customer-logos/homeaway-logo.png";